import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import Tooltip from 'web-app/react/components/tooltip/tooltip';
import { ProfileImageTooltip } from './profile-image-tooltip';
export const ProfileImageTooltipComposer = (props) => {
    const { items, children, tooltipPlacement, emptyImageSrc, disabled } = props;
    return (_jsx(Tooltip, { placement: tooltipPlacement, overlay: Array.isArray(items) ? (_jsx(StyledUl, { children: items.map((item, i) => (_jsx(ProfileImageTooltip, { item: item, emptyImageSrc: emptyImageSrc }, i))) })) : (_jsx(ProfileImageTooltip, { item: items, emptyImageSrc: emptyImageSrc })), ...(disabled ? { visible: false } : {}), children: children }));
};
const StyledUl = styled.ul `
    max-height: 80vh;
    overflow: auto;
    padding-right: ${props => props.theme.mf.spacing(5)} !important;

    &::-webkit-scrollbar {
        background: transparent;
        height: 8px;
        width: 6px;
    }
    &::-webkit-scrollbar-thumb {
        border: none;
        box-shadow: none;
        background: ${props => props.theme.mf.colorPalette.n400};
        border-radius: 6px;
        min-height: 8px;
    }

    scrollbar-color: ${props => props.theme.mf.colorPalette.n400} transparent;
    scrollbar-width: thin;
`;
